import React, { Fragment, useEffect, useState } from 'react';
import { setUser } from './redux/userSlice';
import { setCompany } from './redux/companySlice';
import { pendingCount } from './redux/IOMPendingCount';
import { useNavigate } from 'react-router-dom';
import { getStoredUser } from './helper/sessionHelper';
import AppRoutes from './components/routes/AppRoutes';
import { useDispatch, useSelector } from "react-redux";
import { setDeviceInfo } from './redux/deviceInfoSlice';
import { getUserDetailsByAccessToken } from './apis/apiServices/User';
import secureLocalStorage from 'react-secure-storage';
import '../src/App.css';
import { ClearSessionItems } from './helper/appsession';
import { getUserDetailsByRefrestToken } from './apis/apiServices/User';
import { getCurrencyIcon } from './helper/appsession';
import Swal from 'sweetalert2';
import { RedirectLogInLoader } from './components/Shared/PageLoader';
import { GetUserWiseFeatureMenu, GetUserFeaturePermission, getApplicationModuleFeature } from './apis/apiServices/User';
import { setFeatureMenu } from './redux/featureMenuSlice';
import { setUserFeature } from './redux/userFeatureSlice';
import { getStoredFeatureMenu } from './helper/sessionHelper';
import { getStoredUserFeatures } from './helper/sessionHelper';
import { getStoredCompany } from './helper/sessionHelper';
import { SystemCheckService } from './apis/apiServices/SystemCheck';
import axiosApi from "../src/apis/axiosInstance";


function App() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.data);
  const [loading, setLoading] = useState(true);
  const [systemCheck, setSystemCheck] = useState({
    isModalOpen: false,
  });

  const [companyIdFromVishwam, setCompanyIdFromVishwam] = useState(null);

  useEffect(() => {
    //user?.isIframe ? setLoading(true) : setLoading(false);
    setDeviceInfoInReduc();
    const storedUser = getStoredUser();
    if (storedUser) {
      dispatch(setUser(storedUser));
    }
    const pendingCounts = sessionStorage.getItem("session_pendingCount");
    if (pendingCounts) {
      dispatch(pendingCount(pendingCounts));
    }
  }, [dispatch]);

  const performLoginActions = async (action, params) => {
    if (action === "approveIom") {
      let iomId = params?.get("iomId");
      let isApproved = params?.get("isApproved");

      navigate("/iom-preview", { state: { iomId: iomId, action: action, isApproved: isApproved } });
    }
    if (action === "recallIom") {
      let iomId = params?.get("iomId");
      navigate("/iom-preview", { state: { iomId: iomId, action: action, fromRecallRequestPage: true } });
    }
    if (action === "viewIom") {
      let iomId = params?.get("iomId");
      navigate("/iom-preview", { state: { iomId: iomId, action: action } });
    }
    if (action === "editIom") {
      let iomId = params?.get("iomId");
      navigate("/new-inter-office-memo", { state: { iomId: iomId, action: action } });
    }
  }

  const fetchUserWiseFeatureMenu = async (userId, applicationId, companyId) => {
    try {
      let request = {}
      request.userId = userId;
      request.applicationId = 2;
      request.companyId = companyId || companyIdFromVishwam || getStoredCompany()?.companyId || 0;

      let response = await GetUserWiseFeatureMenu(request);

      return response;

    } catch (error) {
      return null;
    }
  };
  const fetchUserFeaturePermission = async (userId, applicationId, companyId) => {
    try {
      let request = {}
      request.userId = userId;
      request.applicationId = 2;
      request.companyId = companyId || companyIdFromVishwam || getStoredCompany()?.companyId || 0;

      let response = await GetUserFeaturePermission(request);

      return response;

    } catch (error) {
      return null;
    }

  };

  const validateUsersLoginDateTime = (timestampString) => {
    const timestamp = parseInt(timestampString, 10);
    const UrlUtcDate = new Date(timestamp).toISOString();

    if (Date.now() < timestamp) { // valid for 5 minutes
      return true;
    } else {
      Swal.fire("Warning", "Session Expired", "error").then(() => {
        window.location.href = process.env.REACT_APP_VISHWAM_BASE_URL;
      })
      return false;
    }
  }
  const fetchUserDetailsByRefrestToken = async (refreshToken, action, params, companyId, isIframe) => {
    
debugger
    const currencyIcon = getCurrencyIcon("inr");
    const jwtToken = await refreshAccessToken(refreshToken);

    let response = await getUserDetailsByRefrestToken({ refreshToken, companyId });
    
    if (response?.isSuccess) {


      if (!isIframe) {
        let userWiseFeatureMenuResponse = await fetchUserWiseFeatureMenu(response?.data?.userId, 2, companyId);
        if (userWiseFeatureMenuResponse?.isSuccess) {
          secureLocalStorage.setItem("featureMenu", userWiseFeatureMenuResponse?.data);
          dispatch(setFeatureMenu(userWiseFeatureMenuResponse?.data || {}));
        }
      }

      let userFeaturePermission = await fetchUserFeaturePermission(response?.data?.userId, 2);


      if (userFeaturePermission?.isSuccess) {
        secureLocalStorage.setItem("userFeatures", userFeaturePermission?.data);
        dispatch(setUserFeature(userFeaturePermission?.data || {}));
      }

      // console.log("response?.data", response);
      const userPayload = {
        authorized: true,
        currencyIcon,
        userId: response?.data?.userId,
        userName: response?.data?.username,
        firstName: response?.data?.firstName || "",
        lastName: response?.data?.lastName || "",
        empId: response?.data?.employeeId,
        userDepartmentId: response?.data?.userCompany?.userDepartmentId,
        // userDepartmentName: response?.data?.departmentName,
        userDepartmentName: response?.data?.userCompany?.userDepartmentName,
        userDesignationId: response?.data?.userCompany?.userDesignationId,
        userDesignationName: response?.data?.userCompany?.userDesignationName,
        levelId: response?.data?.levelId,
        levelCode: response?.data?.levelCode,
        isIframe: isIframe,
        refreshToken: refreshToken,
        accessToken: jwtToken,
      };
      dispatch(setUser(userPayload));


      const companyPayload = {
        ...response?.data?.userCompany,
        isChangeCompanyModalOpen: false,
      }

      console.log("companyPayload-=--", companyPayload)
      dispatch(setCompany(companyPayload));

      ClearSessionItems();
      secureLocalStorage.setItem("user", userPayload);
      secureLocalStorage.setItem("company", companyPayload);
      secureLocalStorage.setItem("authorized", true);
      secureLocalStorage.setItem("currencyicon", currencyIcon);

      if (action) {
        await performLoginActions(action, params);
      }
    } else {
      setLoading(false);
      await Swal.fire("Error", response?.data?.message, "error").then(() => {
        window.location.href = process.env.REACT_APP_VISHWAM_BASE_URL;
      })
      return;
    }

    const newUrl = window.location.origin + window.location.pathname;
    window.history.replaceState({}, document.title, newUrl);

    setLoading(false);
  };

  const detectBrowser = () => {
    var ua = navigator.userAgent;
    var tem;
    var M = ua.match(/(opera|chrome|safari|firefox|msie|trident)\/?\s*(\d+(\.\d+)*)/i) || [];

    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+(\.\d+)?)/g.exec(ua) || [];
      return ['Internet Explorer', tem[1] || ''];
    }

    if (M[1] === 'Chrome') {
      tem = ua.match(/\b(OPR|Edg)\/(\d+(\.\d+)?)/);
      if (tem != null) {
        return [tem[1] === 'OPR' ? 'Opera' : 'Edge', tem[2]];
      }
    }

    if (M[1]) {
      if ((tem = ua.match(/version\/(\d+(\.\d+)?)/i)) != null) {
        M[2] = tem[1];
      }
      return [M[1], M[2]];
    }

    return [navigator.appName, navigator.appVersion];
  }
  const detectOS = () => {
    const platform = navigator.platform.toLowerCase();
    const userAgent = navigator.userAgent.toLowerCase();

    if (platform.includes('win')) return 'Windows';
    if (platform.includes('mac')) return 'macOS';
    if (platform.includes('linux')) return 'Linux';
    if (/android/.test(userAgent)) return 'Android';
    if (/iphone|ipad|ipod/.test(userAgent)) return 'iOS';

    return 'Unknown OS';
  }
  const setDeviceInfoInReduc = async () => {
    const [browserName, browserVersion] = detectBrowser();
    const [osName, osVersion] = detectOS();
    const isMobile = navigator?.userAgentData?.mobile;
    const ipResponse = await fetch("https://api.ipify.org/?format=json");
    const ipData = await ipResponse.json();
    const ipAddress = ipData.ip;

    let deviceInfoPayload = {
      isMobile: isMobile,
      iPAddress: ipAddress,
      deviceInfo: `OS: ${osName} ${osVersion} || Browser: ${browserName} ${browserVersion}`,

      browserName: browserName,
      browserVersion: browserVersion,
      osName: osName,
      osVersion: osVersion,
      isMobile: isMobile,
      ipAddress: ipAddress,
    };

    secureLocalStorage.setItem("deviceInfo", deviceInfoPayload);
    dispatch(setDeviceInfo(deviceInfoPayload));
  }

  const startSystemCheckInterval = (intervalMinutes = 1) => {

    const interval = setInterval(async () => {
      const body = {
        environmentId: process.env.REACT_APP_ENVIRONMENT,
        deviceTypeId: 3
      }
      const appVersion = process.env.REACT_APP_VERSION;
      const response = await SystemCheckService.systemCheck(body);
      if (systemCheck?.isModalOpen) return;

      if (response?.isSuccess) {
        if (response?.data?.digilinkZWebVersion !== String(appVersion)) {
          setSystemCheck(prevState => ({ ...prevState, isModalOpen: true, }))

          Swal.fire({
            title: 'Site Update',
            html: 'A new version has been released. Would you like to continue with the updated version? <div style="margin-top:20px;background-color: #fdf1e1; padding:10px; border:1px solid #ebc99c;text-align:left;color:#a57637; font-size:12px;"><strong>Update Now:</strong> <ul><li>Clears cache and browsing history</li><li>Reloads the site with the latest version</li></ul><strong>Skip & Continue:</strong> <ul style="margin-bottom:10px;"><li>Keeps your existing cache and browsing history</li><li>You’ll continue using the older version of the site</li></ul></div>',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Skip & Continue',
            confirmButtonText: 'Update Now',
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload(true);
            } else {
              setSystemCheck(prevState => ({ ...prevState, isModalOpen: false, }))
            }
          });
        }
      }
    }, 300000); //intervalMinutes * 60 * 1000

    return interval;
  };


  useEffect(async () => {
    const params = new URLSearchParams(window.location.search);

    const userId = params?.get("userId");
    const refreshToken = params?.get("refreshToken");
    const validity = params?.get("validity");
    const action = params?.get("action");
    const companyId = params?.get("companyId");
    // const isIframe = params?.get("isIframe");

    const isActuallyInIframe = window.self !== window.top;
    const isBrowserReload =
      performance.getEntriesByType("navigation")[0]?.type === "reload";


    const isIframe = isBrowserReload ? false : isActuallyInIframe;

    setCompanyIdFromVishwam(companyId);

    if (refreshToken) { // First-time login: fetch using token
      if (validity) {
        let isTokenDateValid = validateUsersLoginDateTime(validity)
        if (!isTokenDateValid) {
          setLoading(false);
          return;
        }
      }
      fetchUserDetailsByRefrestToken(refreshToken, action, params, Number(companyId), isIframe);
    }
    else if (userId && user?.authorized) {
      if (userId && action && Number(userId) === user?.userId) {
        await performLoginActions(action, params);
      }
      else if (userId && action && Number(userId) !== user?.userId) {
        Swal.fire("", "You are not intented user to access this page.", "warning");
      }

      setLoading(false);
    }
    else {
      const storedUser = getStoredUser();
      const storecCompany = getStoredCompany();
      var storedUserFeatures = getStoredUserFeatures();
      var featureMenu = getStoredFeatureMenu();


      if (storedUser?.authorized) {
        if (userId && action && Number(userId) === storedUser?.userId) {
          await performLoginActions(action, params);
        } else if (userId && action && Number(userId) !== storedUser?.userId) {
          Swal.fire("", "You are not intented user to access this page.", "warning");
        }

        const userPaylaod = { ...storedUser, isIframe: isIframe }
        // Restore user from local/session storage if Redux is empty
        dispatch(setUser(userPaylaod));
        // dispatch(setUser(storedUser));
        dispatch(setCompany(storecCompany));

        let featureMenuResponse = await fetchUserWiseFeatureMenu(storedUser?.userId, 1, companyId)
        if (featureMenuResponse?.isSuccess) {
          featureMenu = featureMenuResponse?.data;
        }

        let userFeaturesResponse = await fetchUserFeaturePermission(storedUser?.userId, 1);
        if (userFeaturesResponse?.isSuccess) {
          storedUserFeatures = userFeaturesResponse?.data;
        }

        if (storedUserFeatures) {
          dispatch(setUserFeature(storedUserFeatures));
        }
        if (featureMenu) {
          dispatch(setFeatureMenu(featureMenu));
        }

        setLoading(false);
      }
      else {
        // No token, no session, redirect to login/base site
        window.location.href = process.env.REACT_APP_VISHWAM_BASE_URL;
      }
    }
  }, []);

  useEffect(() => {
    if (!user) return;

    const systemCheckInterval = startSystemCheckInterval(3)

    return () => {
      clearInterval(systemCheckInterval);
    };
  }, [user]);


  async function refreshAccessToken(refreshToken) {
  const request = {
    refreshToken: refreshToken || "",
    accessToken: localStorage.getItem("session_accesstoken") || "",

  };
  var response = await axiosApi
    .post("/Authentication/RefreshJWTToken", request, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => res);
  console.log("refresh token response", response);
  if (response.status === 200) {
    localStorage.removeItem("session_accesstoken");
    localStorage.setItem("session_accesstoken", response?.data?.data || "");
    return response.data?.data || "";
  }
  return null;
}

  if (loading) {
    return <div style={{ backgroundColor: "#fff", width: "100%", height: "100%" }}>
      {/* <RedirectLogInLoader /> */}
    </div>;
  }
  return (
    <Fragment>
      <AppRoutes />
    </Fragment>
  );
}

export default App;
